import React from "react";
import "./CSS/Admin.css";
import Sidebar from "../Components/Sidebar/Sidebar";
import AddProduct from "../Components/AddProduct/AddProduct";
import { Route, Routes } from "react-router-dom";
import ListProduct from "../Components/ListProduct/ListProduct";
import OrderDetails from "./Orders";
import VarietyAccessories from "./varietyAccessories";
import DesignPatterns from "./designPatterns";
import EditProduct from "../Components/EditProduct/editProduct";
import BrowseByVideos from "./browseByVideos";
import TopSellersRetro from "./topSellersRetro";
import LandingBanner from "./landingBanner";
import NewArrivals from "./newArrivals";
import BrowseCategory from "./browseCategory";
import FAQ from "./FAQ";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ExploreIdeas from "./exploreIdeas";
import FeaturedIn from "./featuredIn";
import PromoCodes from "./promoCodes";
import HomePageReviews from "./homeReviews";
import Customers from "./customers";

const Admin = () => {
  return (
    <div className="admin">
      <Sidebar />
      <Routes>
        
      <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/addproduct" element={<AddProduct />} />
        <Route path="/listproduct" element={<ListProduct />} />
        <Route path="/promo-codes" element={<PromoCodes />} />
        <Route path="/orders" element={<OrderDetails />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/editproduct/:id" element={<EditProduct />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/explore-our-ideas" element={<ExploreIdeas />} />
        <Route path="/homepage/varietyofaccessories" element={<VarietyAccessories />} />
        <Route path="/homepage/shopbydesignpatterns" element={<DesignPatterns />} />
        <Route path="/homepage/browsebyvideos" element={<BrowseByVideos />} />
        <Route path="/homepage/topsellers-retrocollections" element={<TopSellersRetro />} />
        <Route path="/homepage/landingbanners" element={<LandingBanner />} />
        <Route path="/homepage/newarrivals" element={<NewArrivals />} />
        <Route path="/homepage/browsebycategory" element={<BrowseCategory />} />
        <Route path="/homepage/featured-in" element={<FeaturedIn />} />
        <Route path="/homepage/reviews" element={<HomePageReviews />} />
      </Routes>
    </div>
  );
};

export default Admin;
